import { render, staticRenderFns } from "./DocumentElementPicker.vue?vue&type=template&id=8c8f5de8&scoped=true"
import script from "./DocumentElementPicker.vue?vue&type=script&lang=js"
export * from "./DocumentElementPicker.vue?vue&type=script&lang=js"
import style0 from "./DocumentElementPicker.vue?vue&type=style&index=0&id=8c8f5de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8f5de8",
  null
  
)

export default component.exports